import { createAction } from '@reduxjs/toolkit';

export const deliveryDatesDialogOpen = createAction<Record<string, boolean>>(
  'delivery-dates-dialog/open'
);
